import { Checkbox } from '@mui/material';

const ColumnHeader = ({
  onSelectChanged,
  removeAllColumn,
  isChecked,
  setIsChecked,
  indeterminate,
  setIndeterminate,
}) => {
  return (
    <div className="ag-cell-label-container" role="presentation">
      <div className="ag-header-cell-label" role="presentation">
        <Checkbox
          checked={isChecked}
          onChange={(e) => {
            if (e.target.name === 'allrecord') {
              if (e.target.checked) {
                onSelectChanged(1);
                setIsChecked(true);
              } else {
                onSelectChanged(0);
                setIsChecked(false);
                removeAllColumn();
              }
              setIndeterminate(false);
            }
          }}
          indeterminate={indeterminate}
          name="allrecord"
          color="primary"
          size="small"
          style={{
            marginLeft: '-11px',
            marginRight: '-11px',
          }}
        />
      </div>
    </div>
  );
};

export default ColumnHeader;
